import React, { Component } from "react";
import ProductCard from "./ProductCard";
import group1 from "./Skarvdata";
import Info from "./Info";
import Nyhetsbrev from "./Nyhetsbrev";

class Products extends Component {
  static defaultProps = { grp: group1 };

  render() {
    return (
      <div className="Products">
        <div className="container-fluid bg-dark mt-4">
          <div className="row d-flex">
            <Info imgSrc="./img/00.png" />

            {this.props.grp.map((p) => (
              <ProductCard key={p.ppid1} id={p.id} tittel={p.tittel} beskrivelse={p.beskrivelse} ppid1={p.ppid1} ppid2={p.ppid2} ppid3={p.ppid3} vippsId1={p.vippsId1} vippsId2={p.vippsId2} vippsId3={p.vippsId3} pris1={p.pris1} pris2={p.pris2} pris3={p.pris3} farge={p.farge} caro={p.caro} caroId={p.caroId} caroId2={p.caroId2} activeCaro={p.activeCaro} />
            ))}
            <Nyhetsbrev imgSrc="./img/00.png" />
          </div>
        </div>
      </div>
    );
  }
}

export default Products;
